import { ref } from 'vue';
import { injectService } from '@patsnap/tahiti-core/ioc/inject';
import { ClientService } from '@telecom/shared/services/client/client-service';

export const useClient = () => {
    const clientService = injectService<ClientService>(ClientService);

    const isEureka = ref(clientService.isEureka);

    return {
        isEureka,
    };
};
